import React from "react";
import { ISyndicationPartner } from "types/syndication.service";

const UseManagePartnerContext = React.createContext<{
  syndicationPartnerData?: ISyndicationPartner;
} | null>(null);

export default UseManagePartnerContext;
